import { useEffect, useState } from "react";
import { api, currency } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

function scoreColor(s) {
  if (s >= 70) return "#156F52";
  if (s >= 40) return "#D5A44A";
  return "#B54747";
}

export default function Scorecards() {
  const [cards, setCards] = useState(null);

  useEffect(() => {
    api.get("/scorecards").then((r) => setCards(r.data));
  }, []);

  if (!cards)
    return (
      <div className="space-y-4">
        <Skeleton className="h-10 w-72" />
        {[...Array(3)].map((_, i) => <Skeleton key={i} className="h-32" />)}
      </div>
    );

  return (
    <div>
      <div className="mb-8">
        <p className="font-mono-data text-xs uppercase tracking-[0.2em] text-[#B54747]">Head-to-head</p>
        <h1 className="font-display text-4xl font-light mt-1">Vendor Scorecards</h1>
        <p className="text-sm text-zinc-500 mt-2">
          Compare every vendor on spend, signed cases, cost per case and ROI — independent of the vendor's own report.
        </p>
      </div>

      {cards.length === 0 && (
        <div className="border border-dashed border-zinc-300 p-16 text-center text-zinc-500">
          Add vendors and leads to generate scorecards.
        </div>
      )}

      <div className="space-y-4">
        {cards.map((c, i) => (
          <div key={c.vendor_id} className="border border-zinc-200 bg-white p-6" data-testid={`scorecard-${c.vendor_id}`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <span className="font-display text-3xl text-zinc-300">#{i + 1}</span>
                <div>
                  <p className="font-mono-data text-[10px] uppercase tracking-widest text-zinc-500">{c.category}</p>
                  <h3 className="font-display text-2xl">{c.vendor_name}</h3>
                </div>
              </div>
              <div className="text-right">
                <div className="flex items-center gap-3">
                  <div className="w-28 h-2 bg-zinc-100 overflow-hidden">
                    <div className="h-full transition-all duration-500" style={{ width: `${c.score}%`, background: scoreColor(c.score) }} />
                  </div>
                  <span className="font-display text-4xl" style={{ color: scoreColor(c.score) }} data-testid={`score-value-${c.vendor_id}`}>
                    {c.score}
                  </span>
                </div>
                <p className="font-mono-data text-[10px] uppercase tracking-widest text-zinc-500 mt-1">Vendor score</p>
              </div>
            </div>
            <div className="grid grid-cols-3 md:grid-cols-6 gap-4 border-t border-zinc-100 pt-4">
              {[
                { l: "Spend", v: currency(c.spend) },
                { l: "Leads", v: c.leads },
                { l: "Qualified", v: c.qualified },
                { l: "Signed", v: c.signed },
                { l: "Cost / case", v: c.cost_per_case ? currency(c.cost_per_case) : "—" },
                { l: "ROI", v: c.roi != null ? `${c.roi}%` : "—", color: c.roi != null ? (c.roi >= 0 ? "#156F52" : "#B54747") : null },
              ].map((m) => (
                <div key={m.l}>
                  <p className="font-mono-data text-[10px] uppercase tracking-widest text-zinc-500">{m.l}</p>
                  <p className="font-mono-data text-lg mt-1" style={m.color ? { color: m.color } : {}}>{m.v}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
